export { default as ThankYouPage } from './components/ThankYouPage';
export { default as ThankYouPageArgo } from './components/ThankYouPageArgo';
